export * from './kunden-list.component';
export * from './kunden-list.component.module';